import {useNavigate} from "react-router-dom";
import DataProvider from "../management-lib/util/DataProvider";
import Manage from "../management-lib/util/manage/Manage";

export default function({dataProvider = new DataProvider("province")}) {

    const navigate = useNavigate();

    return (
        <Manage create={true} title="Provinces" dataProvider={dataProvider} columns={[
            {id: "name"}
        ]}
        onClick={(i) => navigate(i.id)}
        />
    )
}